import { Title } from "@/common/ui/Text";
import React from "react";
import { motion } from "framer-motion";
import { Col } from "@/common/css";
import { generateAcronym } from "@/utils/helper/string";

interface ProfileIconProps {
  name: string;
  role?: string;
  hideName?: boolean;
  className?: string;
}

const ProfileIcon: React.FC<ProfileIconProps> = ({ name, hideName = false, role, className = "w-8 h-8 bg-brand-white" }) => {
  const acroNym = generateAcronym(name);

  return (
    <motion.div className="flex items-center bg-transparent gap-x-2">
      {!hideName && (
        <Col className=" items-end">
          <Title text={name} className=" truncated-text" />
          {role && <span className="text-text-default font-normal !leading-normal text-10">{role}</span>}
        </Col>
      )}
      <motion.div className={`flex items-center justify-center border-2 border-text-primary rounded-full text-text-primary font-bold text-10 ${className}`}>
        {acroNym}
      </motion.div>
    </motion.div>
  );
};

export default ProfileIcon;
